import React from 'react';

const SVG = ({
  style = {},
  fill = '#9192a4',
  width = '100%',
  className = '',
  viewBox = '0 0 25 25',
  title = 'Support Simple',
}: any) => (
  <svg
    fill={fill}
    width={width}
    style={style}
    className={`svg ${className}`}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <style>
        {`
          .svg-support-simple-1 { fill: none; }
          .svg-fill-support-simple { fill: ${fill}; }
        `}
      </style>
    </defs>
    <title>{title}</title>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <rect
          id="Rectangle_941"
          data-name="Rectangle 941"
          className="svg-support-simple-1"
          width="25"
          height="25"
        />
        <path
          className="svg-fill-support-simple"
          d="M16.15,12a3.73,3.73,0,0,0,3.94-5.13.57.57,0,0,0-.73-.31h0a.48.48,0,0,0-.17.12L17.32,8.53l-.73-.15-.14-.74,1.84-1.85a.56.56,0,0,0,.17-.4A.52.52,0,0,0,18.29,5a.4.4,0,0,0-.13-.13,3.66,3.66,0,0,0-4.89,2,3.72,3.72,0,0,0-.25,2,1.08,1.08,0,0,1-.28,1l-.5.51L9.77,7.82l-.52-1A.47.47,0,0,0,9,6.55L6.52,5.13a.55.55,0,0,0-.66.1l-.55.56a.55.55,0,0,0-.1.66L6.61,9a.51.51,0,0,0,.23.23l1,.55,2.47,2.49-.5.52a1.05,1.05,0,0,1-1,.27,3.73,3.73,0,0,0-4,5.14.56.56,0,0,0,.35.23.53.53,0,0,0,.39,0,.45.45,0,0,0,.17-.11l1.89-1.81.73.15.14.73L6.73,19.22a.59.59,0,0,0,0,.8.76.76,0,0,0,.19.12,3.72,3.72,0,0,0,1.44.31,4.08,4.08,0,0,0,1.38-.27,3.7,3.7,0,0,0,2-2,3.81,3.81,0,0,0,.25-2,1.1,1.1,0,0,1,.27-1l.51-.52.16.16-.16.16a1.35,1.35,0,0,0,1.41,2.23l2.25,2.25a2,2,0,0,0,1.46.6H18A2.15,2.15,0,0,0,20,17.83a2.18,2.18,0,0,0-.56-1.35L17.2,14.19A1.34,1.34,0,0,0,15,12.77l-.16.16-.15-.16.5-.51A1.06,1.06,0,0,1,16.15,12Zm-1.79-.49-2.88,2.94a2.16,2.16,0,0,0-.59,1.92,2.61,2.61,0,0,1-2.17,3,2.17,2.17,0,0,1-.51,0l1.35-1.37a.54.54,0,0,0,.16-.51L9.5,16a.53.53,0,0,0-.45-.44L7.68,15.3a.56.56,0,0,0-.51.15L5.82,16.81A2.6,2.6,0,0,1,8,14.13a2.21,2.21,0,0,1,.81,0,2.19,2.19,0,0,0,1.93-.59l2.89-2.94a2.22,2.22,0,0,0,.54-1.91,2.6,2.6,0,0,1,2.16-3,2.09,2.09,0,0,1,.5,0L15.44,7.09a.53.53,0,0,0-.15.5L15.57,9a.54.54,0,0,0,.43.44l1.39.27a.55.55,0,0,0,.51-.15l1.34-1.36a2.58,2.58,0,0,1-2.42,2.73,2.33,2.33,0,0,1-.53,0A2.19,2.19,0,0,0,14.36,11.49Z"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
